import * as React from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  Label,
} from "recharts";

const ShareLineChart = ({ data }) => {
  // Detect API format
  const isApiFormat =
    data && data.labels && data.data && Array.isArray(data.labels);

  // Transform if API format
  const chartData = isApiFormat
    ? data.labels.map((label, index) => ({
        month: label,
        value: data.data[index],
      }))
    : data;

  if (!chartData || chartData.length === 0) {
    return (
      <div className="w-full h-[280px] flex items-center justify-center border border-gray-200 rounded-lg bg-gray-50">
        <p className="text-gray-600">No data available</p>
      </div>
    );
  }

  return (
    <ResponsiveContainer width="100%" height={280}>
      <LineChart
        data={chartData}
        margin={{ top: 20, right: 30, left: 20, bottom: 10 }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="month" axisLine={{ stroke: "#D9D9D9" }}>
          <Label
            value={isApiFormat && data.bucket === "week" ? "Weeks" : "Months"}
            position="insideBottom"
            offset={-10}
          />
        </XAxis>
        <YAxis
          domain={["auto", "auto"]}
          tickFormatter={(value) => new Intl.NumberFormat()?.format(value)}
          axisLine={{ stroke: "#D9D9D9" }}
        />
        <Tooltip
          formatter={(value) => [
            value,
            isApiFormat ? data.seriesName : "Value",
          ]}
        />
        <Line
          type="monotone"
          dataKey="value"
          stroke="#FF5757"
          strokeWidth={1}
          dot={{ r: 3 }}
          activeDot={{ r: 5 }}
        />
      </LineChart>
    </ResponsiveContainer>
  );
};

export default ShareLineChart;
